import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "../cn.js";
const V = {
    primary: "bg-navy text-white hover:bg-navy-deep disabled:bg-ink-3",
    secondary: "bg-surface text-navy border border-line hover:bg-tint",
    ghost: "bg-transparent text-ink-2 hover:bg-tint hover:text-navy",
    danger: "bg-danger text-white hover:brightness-95",
};
const S = { sm: "h-9 px-3 text-xs", md: "h-11 px-4 text-sm", lg: "h-12 px-5 text-base" };
/** Field-ready buttons: min 44 px tap target on lg, visible focus, loading state. */
export function Button({ variant = "primary", size = "md", icon, loading, className, children, disabled, ...rest }) {
    return (_jsxs("button", { type: "button", disabled: disabled || loading, className: cn("inline-flex shrink-0 items-center justify-center gap-2 rounded-md font-semibold transition-colors active:brightness-95 disabled:cursor-not-allowed disabled:opacity-70", V[variant], S[size], className), ...rest, children: [loading ? _jsx("span", { "aria-hidden": true, className: "h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent" }) : icon, children] }));
}
//# sourceMappingURL=Button.js.map